<div class="tw-center tw-flex tw-column tw-padding-10" >

  <div class="tw-flex tw-row" >
    <div style="padding: 10px 10px 10px 0;margin-right: 10px"> <h2>1.Nombre de billets requis </h2></div>
    <div style="padding:  25px 0">
      <button class="tw-button-price tw-primary" (click)="qtyMinusOnePl()" >
        -
      </button>
    </div>
    <div style="padding: 25px 0">
      <input value="{{qty}}"
                   style="width: 40px ;
                           font-weight: bold;
                           font-size: 20px;
             text-align: center;
             background: white;
             border: none;"
        disabled>
    </div>

    <div style="padding: 25px 0">
      <button   class="tw-button-price tw-primary" (click)="qtyPlusOnePl()">
        +
      </button>
    </div>

  </div>
  <div class="tw-flex tw-column" style="width: 400px">
    <h2>2.Selection voter section</h2>
    @for (pl of priceLevels; track pl; let i = $index) {
      @for (price of pl.prices; track price; let i = $index) {
        <div [ngStyle]="{'border-color': pl.color}" class="tw-flex tw-row"
          style="height: 100px;width: 100%;margin: 5px;border: 2px;border-style:solid; ">
          <div style="width:13px" [ngStyle]="{'background':''+pl.color}"></div>
          <div class="tw-flex tw-column" style="flex-grow: 5">
            <div style="padding: 6px;text-align: left;">
              {{ price.name }}
            </div>
            <div style="padding: 6px">
              <strong>{{(price.price / 100) | currency }}</strong>
              <br>
                {{pl.min / 100 | currency }} -  {{pl.max / 100 | currency }}
              </div>
            </div>
            <div class="tw-flex tw-row" style="padding-right: 10px">
              <div style="padding:  25px 0">
                <button color="primary"  (click)="qtyMinusOnePl()" >
                  <mat-icon aria-label="" >remove</mat-icon>
                </button>
              </div>
              <div style="padding: 25px 0">
                <input value="{{qty}}"
                                   style="width: 40px ;
                                         font-weight: bold;
                                         font-size: 30px;
                                         text-align: center;
                                         background: white;
                                         border: none;"
                  disabled>
              </div>
              <div style="padding: 25px 0">
                <button  color="primary" (click)="qtyPlusOnePl()">
                  <mat-icon aria-label="">add</mat-icon>
                </button>
              </div>
            </div>
          </div>
        }
      }

    </div>
  </div>
